export default class GeometryFilter {
  filter(geom) {}
}
